import excute from "./pos/excute";

const createMenuList = (props) => {
  return excute({ ...props, type: 'MenuList'});
}

export default createMenuList;